module.exports = __webpack_public_path__ + "img/play_color.04c68276.svg";